import apiService from './apiService';
import {
  DEFAULT_AIR_RATE_PER_KG,
  DEFAULT_SEA_RATE_PER_CBM,
  DEFAULT_IMPORT_FEES_RATE,
  DEFAULT_BANKING_FEES_RATE,
  DEFAULT_INSURANCE_TIERS,
  DEFAULT_IMPORT_FEES_CAP_THRESHOLD,
  DEFAULT_IMPORT_FEES_CAP_AMOUNT,
  AVION_PAYMENT_RATIO,
  AIR_MEASURE_STEP,
} from '../constants/shipping';

/**
 * Barème utilisé tant que l'API n'a pas répondu, ou si elle est injoignable.
 * Aucun de ces nombres ne fait autorité : ils évitent seulement d'afficher un
 * écran vide le temps de l'appel.
 */
export const FALLBACK_PRICING = {
  perKg: DEFAULT_AIR_RATE_PER_KG,
  perCbm: DEFAULT_SEA_RATE_PER_CBM,
  importFeesRate: DEFAULT_IMPORT_FEES_RATE,
  bankingFeesRate: DEFAULT_BANKING_FEES_RATE,
  insuranceTiers: DEFAULT_INSURANCE_TIERS,
  importFeesCapThreshold: DEFAULT_IMPORT_FEES_CAP_THRESHOLD,
  importFeesCapAmount: DEFAULT_IMPORT_FEES_CAP_AMOUNT,
  airPrepaidRate: AVION_PAYMENT_RATIO,
  airMeasureStep: AIR_MEASURE_STEP,
};

const num = (value, fallback) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

/**
 * Barème public : tarifs de transport et taux de frais, servis par le backend.
 * Route ouverte, l'estimation s'affiche avant connexion.
 */
class PricingService {
  async getPricing() {
    const body = await apiService.get('/pricing');
    const d = body?.data ?? body ?? {};

    return {
      perKg: num(d.amount_per_kg, FALLBACK_PRICING.perKg),
      perCbm: num(d.amount_per_cbm, FALLBACK_PRICING.perCbm),
      importFeesRate: num(d.import_fees_rate, FALLBACK_PRICING.importFeesRate),
      bankingFeesRate: num(d.banking_fees_rate, FALLBACK_PRICING.bankingFeesRate),
      insuranceTiers:
        Array.isArray(d.insurance_tiers) && d.insurance_tiers.length > 0
          ? d.insurance_tiers
          : FALLBACK_PRICING.insuranceTiers,
      importFeesCapThreshold: num(d.import_fees_cap_threshold, FALLBACK_PRICING.importFeesCapThreshold),
      importFeesCapAmount: num(d.import_fees_cap_amount, FALLBACK_PRICING.importFeesCapAmount),
      airPrepaidRate: num(d.air_prepaid_rate, FALLBACK_PRICING.airPrepaidRate),
      airMeasureStep: num(d.air_measure_step, FALLBACK_PRICING.airMeasureStep),
    };
  }
}

const pricingService = new PricingService();
export default pricingService;
